import { render } from "./VerifyDeposits.vue?vue&type=template&id=4f397e46&scoped=true"
import script from "./VerifyDeposits.vue?vue&type=script&lang=js"
export * from "./VerifyDeposits.vue?vue&type=script&lang=js"

import "./VerifyDeposits.vue?vue&type=style&index=0&id=4f397e46&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f397e46"]])

export default __exports__